import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-visible.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const VisibleIcon = createSvgIcon(<Icon />, 'VisibleIcon');
